import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { map, Subscription } from 'rxjs';
import { AuthService } from '../../../../services/auth/auth.service';
import {
  BreadcrumbService,
  IBreadcrumb,
} from '../../../../services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
})
export class BreadcrumbComponent {
  subsriptions: Subscription[] = [];
  isHome = false;
  items: MenuItem[] = [];
  defaultItem?: MenuItem;
  defaultPage = '';
  isAuthenticated$ = this.authService.token$.pipe(map((t) => !!t));
  breadcrumbSegments$ = this.breadcrumbService.breadcrumbSegments$;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    this.subsriptions = [this.getBreadcrumbSub()];
    this.setDefaultItem();
  }

  onBreadcrumbChange(segments: IBreadcrumb[]) {
    this.items = [];
    segments.forEach(async (segment) => {
      const item = await this.getMenuItem(segment);
      if (!item) return;
      this.items = [...this.items, item];
    });
  }

  onBreadcrumbClick(item: IBreadcrumb): void {
    this.breadcrumbService.popUntil(item.id);
  }

  getBreadcrumbSub(): Subscription {
    return this.breadcrumbSegments$.subscribe((segments) => {
      this.onBreadcrumbChange(segments);
    });
  }

  async getMenuItem(segment: IBreadcrumb): Promise<MenuItem | null> {
    if (segment?.route === `/${this.defaultPage}`) {
      this.isHome = true;
      return null;
    } else {
      this.isHome = false;
    }

    const item: MenuItem = segment;
    return item;
  }

  async setDefaultItem() {
    this.defaultItem = {
      icon: 'pi pi-home text-2xl',
      command: () => {
        this.breadcrumbService.clear();
        this.router.navigate([this.defaultPage]);
      },
    };
  }
}
